"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolBorrowAuthority = exports.PoolBorrowAuthorityData = void 0;
const web3_js_1 = require("@solana/web3.js");
const bs58_1 = __importDefault(require("bs58"));
const buffer_1 = require("buffer");
const common_1 = require("@everlend/common");
const program_1 = require("../program");
class PoolBorrowAuthorityData extends common_1.Borsh.Data {
}
exports.PoolBorrowAuthorityData = PoolBorrowAuthorityData;
_a = PoolBorrowAuthorityData;
PoolBorrowAuthorityData.SCHEMA = _a.struct([
    ['accountType', 'u8'],
    ['pool', 'publicKey'],
    ['borrowAuthority', 'publicKey'],
    ['amountBorrowed', 'u64'],
    ['shareAllowed', 'u16'],
]);
class PoolBorrowAuthority extends common_1.Account {
    constructor(publicKey, info) {
        super(publicKey, info);
        if (!this.assertOwner(program_1.GeneralPoolsProgram.PUBKEY)) {
            throw common_1.Errors.ERROR_INVALID_OWNER();
        }
        this.data = PoolBorrowAuthorityData.deserialize(this.info.data);
    }
    static getPDA(pool, borrowAuthority) {
        return program_1.GeneralPoolsProgram.findProgramAddress([
            pool.toBuffer(),
            borrowAuthority.toBuffer(),
        ]);
    }
    static findMany(connection, filters = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield program_1.GeneralPoolsProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        memcmp: {
                            offset: 0,
                            bytes: bs58_1.default.encode(buffer_1.Buffer.from([program_1.AccountType.PoolBorrowAuthority])),
                        },
                    },
                    filters.pool && {
                        memcmp: {
                            offset: 1,
                            bytes: new web3_js_1.PublicKey(filters.pool).toBase58(),
                        },
                    },
                ].filter(Boolean),
            }))
                .map((account) => {
                try {
                    return PoolBorrowAuthority.from(account);
                }
                catch (err) { }
            })
                .filter(Boolean);
        });
    }
}
exports.PoolBorrowAuthority = PoolBorrowAuthority;
//# sourceMappingURL=poolBorrowAuthority.js.map